var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice"},[_c('van-notice-bar',{attrs:{"text":_vm.datas.noticeText,"left-icon":"volume-o","background":_vm.datas.backColor,"color":_vm.datas.textColor}}),_vm._t("deles")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }